import Icon from '@mui/material/Icon'
import MDBox from 'components/MDBox'
import MDPagination from 'components/MDPagination'
import MDTypography from 'components/MDTypography'

function CustomPagination({ pagination, onPageChange, onLimitChange }) {
  const { page, limit, totalPages, totalUsers } = pagination

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage)
    }
  }

  const renderPageNumbers = () => {
    const pages = []
    const maxVisiblePages = 5

    let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2))
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

    // Adjust start page if we're near the end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <MDPagination
          item
          key={i}
          onClick={() => handlePageChange(i)}
          active={page === i}
        >
          {i}
        </MDPagination>
      )
    }

    return pages
  }

  const entriesStart = ((page - 1) * limit) + 1
  const entriesEnd = Math.min(page * limit, totalUsers)

  return (
    <MDBox
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      p={3}
    >
      <MDBox mb={{ xs: 2, sm: 0 }}>
        <MDTypography variant="button" color="secondary" fontWeight="regular">
          Showing {entriesStart} to {entriesEnd} of {totalUsers} entries
        </MDTypography>
      </MDBox>

      {totalPages > 0 && (
        <MDPagination variant="gradient" color="info">
          <MDPagination
            item
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
          >
            <Icon sx={{ fontWeight: 'bold' }}>chevron_left</Icon>
          </MDPagination>

          {renderPageNumbers()}

          <MDPagination
            item
            onClick={() => handlePageChange(page + 1)}
            disabled={page === totalPages}
          >
            <Icon sx={{ fontWeight: 'bold' }}>chevron_right</Icon>
          </MDPagination>
        </MDPagination>
      )}
    </MDBox>
  )
}

export default CustomPagination